// extracts the first part of the product id (line number), required in analytics
const extractLineNumberFromSku = sku => (sku ? sku.split('-').shift() : sku);

export default extractLineNumberFromSku;
